import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import { popSignUp, SignUpElement, SignUpType } from "@faire/retailer-visitor-shared/lib/popSignUp";
import { getAnswer1 } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/components/LoggedOutCategoryPageBelowResults/LoggedOutCategoryPageFAQs/__internal__/LoggedOutCategoryPageC1Answer1Content";
import { DEPRECATED_backwardsCompatibleValues } from "@faire/web--source/common/localization";
import { Button } from "@faire/web--source/slate/Button";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import supportArticle from "@faire/web-api--source/routes/support/articles/articleId";
import React from "react";
// All StrictLocalMsg below have been explicitly discussed offline regarding the usage of the placeholders and their
// usage in translation will be checked thoroughly
var getQuestion1 = function(category, strictLocalize) {
    return strictLocalize({
        id: "FWBWmE",
        defaultMessage: [
            {
                type: 0,
                value: "What "
            },
            {
                type: 1,
                value: "categoryName"
            },
            {
                type: 0,
                value: " products can I buy on Faire at wholesale prices for my store?"
            }
        ]
    }, DEPRECATED_backwardsCompatibleValues({
        categoryName: category.name
    }));
};
var getQuestion2 = function(category, strictLocalize) {
    return strictLocalize({
        id: "9Gur/F",
        defaultMessage: [
            {
                type: 0,
                value: "How can I buy "
            },
            {
                type: 1,
                value: "categoryName"
            },
            {
                type: 0,
                value: " products at wholesale prices for my store?"
            }
        ]
    }, DEPRECATED_backwardsCompatibleValues({
        categoryName: category.name
    }));
};
var getAnswer2 = function(history, category) {
    return /*#__PURE__*/ _jsx(Typography, {
        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "8RfiJa",
            defaultMessage: [
                {
                    type: 0,
                    value: "Whether you\u2019re buying products for a brick-and-mortar store, online shop, or pop-up shop, you can shop "
                },
                {
                    type: 1,
                    value: "categoryName"
                },
                {
                    type: 0,
                    value: " products at wholesale prices on Faire\u2014"
                },
                {
                    type: 8,
                    value: "SignUpLinkFormatting",
                    children: [
                        {
                            type: 0,
                            value: "sign up for free"
                        }
                    ]
                },
                {
                    type: 0,
                    value: ". When you join as a retailer, you\u2019ll unlock wholesale prices with thousands of independent brands. You\u2019ll also get exclusive shopping benefits, including free returns on all opening orders and the option to buy now, pay later. "
                },
                {
                    type: 8,
                    value: "LearnMoreLinkFormatting",
                    children: [
                        {
                            type: 0,
                            value: "Learn more"
                        }
                    ]
                },
                {
                    type: 0,
                    value: "."
                }
            ],
            values: _object_spread_props(_object_spread({}, DEPRECATED_backwardsCompatibleValues({
                categoryName: category.name
            })), {
                SignUpLinkFormatting: function(chunks) {
                    return /*#__PURE__*/ _jsx(Button, {
                        variant: "tertiary",
                        onClick: function() {
                            return popSignUp(history, SignUpType.GENERIC, function() {
                                return null;
                            }, {
                                element: SignUpElement.BELOW_FOLD,
                                sourceId: "category_page_faq_answer_2"
                            });
                        },
                        children: chunks
                    });
                },
                LearnMoreLinkFormatting: function(chunks) {
                    return /*#__PURE__*/ _jsx(Button, {
                        variant: "tertiary",
                        linkTo: supportArticle("360015892572"),
                        target: "_blank",
                        children: chunks
                    });
                }
            })
        })
    });
};
var getQuestion3 = function(category, strictLocalize) {
    return strictLocalize({
        id: "xcuHh/",
        defaultMessage: [
            {
                type: 0,
                value: "How do I find different "
            },
            {
                type: 1,
                value: "categoryName"
            },
            {
                type: 0,
                value: " brands that sell wholesale to retailers like me?"
            }
        ]
    }, DEPRECATED_backwardsCompatibleValues({
        categoryName: category.name
    }));
};
var getAnswer3 = function(category) {
    return /*#__PURE__*/ _jsx(Typography, {
        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "Mbi3AF",
            defaultMessage: [
                {
                    type: 0,
                    value: "Faire\u2019s platform consolidates brands that sell "
                },
                {
                    type: 1,
                    value: "categoryName"
                },
                {
                    type: 0,
                    value: " products at wholesale prices to retailers onto a single site, making it possible to buy from independent brands you might not have come across yet. Just a quick browse through Faire\u2019s "
                },
                {
                    type: 1,
                    value: "categoryName"
                },
                {
                    type: 0,
                    value: " listings can offer you a range of styles that are perfect for your store."
                }
            ],
            values: DEPRECATED_backwardsCompatibleValues({
                categoryName: category.name
            })
        })
    });
};
export var getC1CategoryFAQs = function(history, category, subCategories, strictLocalize) {
    var faqItems = [
        {
            question: getQuestion1(category, strictLocalize),
            answer: getAnswer1(history, category, subCategories)
        },
        {
            question: getQuestion2(category, strictLocalize),
            answer: getAnswer2(history, category)
        },
        {
            question: getQuestion3(category, strictLocalize),
            answer: getAnswer3(category)
        }
    ];
    return faqItems.filter(function(faqItem) {
        return faqItem.question && faqItem.answer;
    });
};
